import { createFileRoute } from "@tanstack/react-router";
import { PublicBookingPage } from "@/features/public-booking/PublicBookingPage";
import { parseBookingSearch, utmFromSearch } from "@/features/public-booking/search-params";

// Cùng khuôn ?ma= + utm_* + ?sdt= với /booking: link rải có thể trỏ thẳng một cơ sở.
export const Route = createFileRoute("/booking/$branchCode")({
  validateSearch: parseBookingSearch,
  component: BookingRoute,
});

function BookingRoute() {
  const { branchCode } = Route.useParams();
  const search = Route.useSearch();
  const utm = utmFromSearch(search);
  return (
    <PublicBookingPage
      initialBranchCode={branchCode}
      {...(search.ma ? { initialPromoCode: search.ma } : {})}
      {...(search.affDauMay ? { initialAffDauMay: search.affDauMay } : {})}
      {...(search.sdt ? { initialPhone: search.sdt } : {})}
      {...(utm ? { initialUtm: utm } : {})}
    />
  );
}
